import Vue from "vue";
// import base64_encode from "locutus/php/url/base64_encode";
// import serialize from "locutus/php/var/serialize";
import dayjs from "dayjs";

// 获取Readable文件大小
Vue.filter("filesize", size => {
    if (size) {
        var i = Math.floor(Math.log(size) / Math.log(1024));
        return (
            (size / Math.pow(1024, i)).toFixed(2) * 1 +
            " " +
            ["B", "kB", "MB", "GB", "TB"][i]
        );
    }
});

// 转化为七牛地址
Vue.filter("qn", (str, suffix) => {
    return `${process.env.MIX_QINIU_URL}/${str ?? "nophoto.png"}${suffix ??
        ""}`;
});

// 转化为七牛下载
Vue.filter("qndown", (str, attname) => {
    return `${process.env.MIX_QINIU_URL}/${str}?attname=${attname ?? ""}`;
});
